import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import moment from 'moment';

document.addEventListener('DOMContentLoaded', function () {
    const elems = document.querySelectorAll('.datepicker-toggler');

    elems.forEach(function (elem) {
        let inputField = elem;
        let hiddenInput = document.getElementById(elem.dataset.for + '_input');
        let isDateTime = inputField.getAttribute('data-datetime') === 'true';
        let isRequired = hiddenInput && hiddenInput.hasAttribute('required');
        let invalidFeedback = document.createElement('div');

        invalidFeedback.className = 'invalid-feedback';
        invalidFeedback.innerText = isDateTime
            ? 'Invalid date format. Please use dd. mm. yyyy HH:mm'
            : 'Invalid date format. Please use dd. mm. yyyy';
        inputField.parentNode.appendChild(invalidFeedback);

        let options = {
            locale: Czech,
            enableTime: isDateTime,
            dateFormat: isDateTime ? "DD. MM. YYYY HH:mm" : "DD. MM. YYYY",
            altInput: false,
            altFormat: isDateTime ? "DD. MM. YYYY HH:mm" : "DD. MM. YYYY",
            allowInput: true,
            allowClear: true,
            parseDate: (datestr, format) => {
                const momentFormat = isDateTime ? ["DD. MM. YYYY HH:mm:ss", "DD. MM. YYYY HH:mm", "DD. MM. YYYY H:mm"] : "DD. MM. YYYY";
                const parsed = moment(datestr, momentFormat, true);
                return parsed.isValid() ? parsed.toDate() : null;
            },
            formatDate: (date, format, locale) => {
                return moment(date).format(format);
            },
            onChange: function (selectedDates, dateStr, instance) {
                const selectedDate = selectedDates[0];

                if (selectedDate) {
                    updateHiddenInput(selectedDate);
                    removeValidationError();
                    const displayFormat = isDateTime ? 'DD. MM. YYYY HH:mm' : 'DD. MM. YYYY';
                    instance.input.value = moment(selectedDate).format(displayFormat);
                } else {
                    hiddenInput.value = '';
                    if (isRequired) {
                        showValidationError();
                    } else {
                        removeValidationError();
                    }
                }
            },
            onClose: function (selectedDates, dateStr, instance) {
                if (!selectedDates || selectedDates.length === 0) {
                    hiddenInput.value = '';
                    inputField.value = '';
                    if (!isRequired) {
                        removeValidationError();
                    }
                }
            }
        };

        const fp = flatpickr(elem, options);

        inputField.addEventListener('blur', function () {
            let dateStr = inputField.value.trim();

            if (dateStr === '') {
                fp.clear();
                hiddenInput.value = '';
                if (isRequired) {
                    showValidationError();
                } else {
                    removeValidationError();
                }
                return;
            }

            let momentFormat = isDateTime ? ["DD. MM. YYYY HH:mm:ss", "DD. MM. YYYY HH:mm", "DD. MM. YYYY H:mm"] : "DD. MM. YYYY";
            let parsedDate = moment(dateStr, momentFormat, true);
            if (parsedDate.isValid()) {
                fp.setDate(parsedDate.toDate(), true);
                removeValidationError();
            } else {
                if (isRequired) {
                    showValidationError();
                }
            }
        });

        function updateHiddenInput(selectedDate) {
            const formattedDate = isDateTime
                ? moment(selectedDate).format('YYYY-MM-DDTHH:mm')
                : moment(selectedDate).format('YYYY-MM-DD');
            hiddenInput.value = formattedDate;
            hiddenInput.dispatchEvent(new Event('input'));
        }

        function showValidationError() {
            inputField.classList.add('is-invalid-custom');
            invalidFeedback.style.display = 'block';
        }

        function removeValidationError() {
            inputField.classList.remove('is-invalid-custom');
            invalidFeedback.style.display = 'none';
        }
    });
});
